"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Icons = /** @class */ (function () {
    function Icons() {
    }
    Icons.Icomoon = {
        accessibility: "icon-accessibility",
        accessibility2: "icon-accessibility2",
        addressBook: "icon-address-book",
        addressBook2: "icon-address-book2",
        addressBook3: "icon-address-book3",
        aidKit: "icon-aid-kit",
        aidKit2: "icon-aid-kit2",
        airplane: "icon-airplane",
        airplane2: "icon-airplane2",
        airplane3: "icon-airplane3",
        airplane4: "icon-airplane4",
        alarm: "icon-alarm",
        alarmAdd: "icon-alarm-add",
        alarmCancel: "icon-alarm-cancel",
        alarmCheck: "icon-alarm-check",
        alarm2: "icon-alarm2",
        album: "icon-album",
        alignBottom: "icon-align-bottom",
        alignCenterHorizontal: "icon-align-center-horizontal",
        alignCenterVertical: "icon-align-center-vertical",
        alignLeft: "icon-align-left",
        alignRight: "icon-align-right",
        alignTop: "icon-align-top",
        ambulance: "icon-ambulance",
        ammo: "icon-ammo",
        ampersand: "icon-ampersand",
        anchor: "icon-anchor",
        android: "icon-android",
        angle: "icon-angle",
        angry: "icon-angry",
        angry2: "icon-angry2",
        antenna: "icon-antenna",
        antenna2: "icon-antenna2",
        apple: "icon-apple",
        apple2: "icon-apple2",
        archery: "icon-archery",
        archive: "icon-archive",
        arrowDown: "icon-arrow-down",
        arrowDownLeft: "icon-arrow-down-left",
        arrowDownLeft2: "icon-arrow-down-left2",
        arrowDownLeft3: "icon-arrow-down-left3",
        arrowDownLeft4: "icon-arrow-down-left4",
        arrowDownLeft5: "icon-arrow-down-left5",
        arrowDownRight: "icon-arrow-down-right",
        arrowDownRight2: "icon-arrow-down-right2",
        arrowDownRight3: "icon-arrow-down-right3",
        arrowDownRight4: "icon-arrow-down-right4",
        arrowDownRight5: "icon-arrow-down-right5",
        arrowDown10: "icon-arrow-down10",
        arrowDown11: "icon-arrow-down11",
        arrowDown12: "icon-arrow-down12",
        arrowDown13: "icon-arrow-down13",
        arrowDown14: "icon-arrow-down14",
        arrowDown15: "icon-arrow-down15",
        arrowDown16: "icon-arrow-down16",
        arrowDown2: "icon-arrow-down2",
        arrowDown3: "icon-arrow-down3",
        arrowDown4: "icon-arrow-down4",
        arrowDown5: "icon-arrow-down5",
        arrowDown6: "icon-arrow-down6",
        arrowDown7: "icon-arrow-down7",
        arrowDown8: "icon-arrow-down8",
        arrowDown9: "icon-arrow-down9",
        arrowLeft: "icon-arrow-left",
        arrowLeft10: "icon-arrow-left10",
        arrowLeft11: "icon-arrow-left11",
        arrowLeft12: "icon-arrow-left12",
        arrowLeft13: "icon-arrow-left13",
        arrowLeft14: "icon-arrow-left14",
        arrowLeft15: "icon-arrow-left15",
        arrowLeft16: "icon-arrow-left16",
        arrowLeft2: "icon-arrow-left2",
        arrowLeft3: "icon-arrow-left3",
        arrowLeft4: "icon-arrow-left4",
        arrowLeft5: "icon-arrow-left5",
        arrowLeft6: "icon-arrow-left6",
        arrowLeft7: "icon-arrow-left7",
        arrowLeft8: "icon-arrow-left8",
        arrowLeft9: "icon-arrow-left9",
        arrowResize: "icon-arrow-resize",
        arrowResize2: "icon-arrow-resize2",
        arrowResize3: "icon-arrow-resize3",
        arrowResize4: "icon-arrow-resize4",
        arrowResize5: "icon-arrow-resize5",
        arrowResize6: "icon-arrow-resize6",
        arrowResize7: "icon-arrow-resize7",
        arrowResize8: "icon-arrow-resize8",
        arrowRight: "icon-arrow-right",
        arrowRight10: "icon-arrow-right10",
        arrowRight11: "icon-arrow-right11",
        arrowRight12: "icon-arrow-right12",
        arrowRight13: "icon-arrow-right13",
        arrowRight14: "icon-arrow-right14",
        arrowRight15: "icon-arrow-right15",
        arrowRight16: "icon-arrow-right16",
        arrowRight2: "icon-arrow-right2",
        arrowRight3: "icon-arrow-right3",
        arrowRight4: "icon-arrow-right4",
        arrowRight5: "icon-arrow-right5",
        arrowRight6: "icon-arrow-right6",
        arrowRight7: "icon-arrow-right7",
        arrowRight8: "icon-arrow-right8",
        arrowRight9: "icon-arrow-right9",
        arrowUp: "icon-arrow-up",
        arrowUpLeft: "icon-arrow-up-left",
        arrowUpLeft2: "icon-arrow-up-left2",
        arrowUpLeft3: "icon-arrow-up-left3",
        arrowUpLeft4: "icon-arrow-up-left4",
        arrowUpLeft5: "icon-arrow-up-left5",
        arrowUpRight: "icon-arrow-up-right",
        arrowUpRight2: "icon-arrow-up-right2",
        arrowUpRight3: "icon-arrow-up-right3",
        arrowUpRight4: "icon-arrow-up-right4",
        arrowUpRight5: "icon-arrow-up-right5",
        arrowUp10: "icon-arrow-up10",
        arrowUp11: "icon-arrow-up11",
        arrowUp12: "icon-arrow-up12",
        arrowUp13: "icon-arrow-up13",
        arrowUp14: "icon-arrow-up14",
        arrowUp15: "icon-arrow-up15",
        arrowUp16: "icon-arrow-up16",
        arrowUp2: "icon-arrow-up2",
        arrowUp3: "icon-arrow-up3",
        arrowUp4: "icon-arrow-up4",
        arrowUp5: "icon-arrow-up5",
        arrowUp6: "icon-arrow-up6",
        arrowUp7: "icon-arrow-up7",
        arrowUp8: "icon-arrow-up8",
        arrowUp9: "icon-arrow-up9",
        atSign: "icon-at-sign",
        atom: "icon-atom",
        atom2: "icon-atom2",
        attachment: "icon-attachment",
        attachment2: "icon-attachment2",
        backspace: "icon-backspace",
        backspace2: "icon-backspace2",
        backward: "icon-backward",
        backward2: "icon-backward2",
        baffled: "icon-baffled",
        baffled2: "icon-baffled2",
        bag: "icon-bag",
        bag2: "icon-bag2",
        balance: "icon-balance",
        balloon: "icon-balloon",
        barcode: "icon-barcode",
        barcode2: "icon-barcode2",
        baseball: "icon-baseball",
        basket: "icon-basket",
        basketball: "icon-basketball",
        battery0: "icon-battery-0",
        battery1: "icon-battery-1",
        battery2: "icon-battery-2",
        battery3: "icon-battery-3",
        battery4: "icon-battery-4",
        battery5: "icon-battery-5",
        battery6: "icon-battery-6",
        batteryCharging: "icon-battery-charging",
        bed: "icon-bed",
        bed2: "icon-bed2",
        bell: "icon-bell",
        bellCheck: "icon-bell-check",
        bellCross: "icon-bell-cross",
        bellMinus: "icon-bell-minus",
        bellPlus: "icon-bell-plus",
        bell2: "icon-bell2",
        bell3: "icon-bell3",
        bike: "icon-bike",
        bin: "icon-bin",
        bin2: "icon-bin2",
        bin3: "icon-bin3",
        bin4: "icon-bin4",
        bin5: "icon-bin5",
        binoculars: "icon-binoculars",
        binoculars2: "icon-binoculars2",
        blocked: "icon-blocked",
        blog: "icon-blog",
        blog2: "icon-blog2",
        blogger: "icon-blogger",
        blogger2: "icon-blogger2",
        boat: "icon-boat",
        bold: "icon-bold",
        bold2: "icon-bold2",
        bomb: "icon-bomb",
        book: "icon-book",
        bookPlay: "icon-book-play",
        book2: "icon-book2",
        book3: "icon-book3",
        bookmark: "icon-bookmark",
        bookmark2: "icon-bookmark2",
        bookmark3: "icon-bookmark3",
        bookmark4: "icon-bookmark4",
        bookmarks: "icon-bookmarks",
        books: "icon-books",
        bottle: "icon-bottle",
        bottle2: "icon-bottle2",
        bottle3: "icon-bottle3",
        bottle4: "icon-bottle4",
        bow: "icon-bow",
        bowling: "icon-bowling",
        bowling2: "icon-bowling2",
        bowtie: "icon-bowtie",
        box: "icon-box",
        boxAdd: "icon-box-add",
        boxRemove: "icon-box-remove",
        brain: "icon-brain",
        bread: "icon-bread",
        briefcase: "icon-briefcase",
        briefcase2: "icon-briefcase2",
        briefcase3: "icon-briefcase3",
        brightnessContrast: "icon-brightness-contrast",
        brightnessHigh: "icon-brightness-high",
        brightnessLow: "icon-brightness-low",
        brightnessMedium: "icon-brightness-medium",
        broom: "icon-broom",
        brush: "icon-brush",
        bubble: "icon-bubble",
        bubbleBlocked: "icon-bubble-blocked",
        bubbleCancel: "icon-bubble-cancel",
        bubbleCheck: "icon-bubble-check",
        bubbleDots: "icon-bubble-dots",
        bubbleDots2: "icon-bubble-dots2",
        bubbleDots3: "icon-bubble-dots3",
        bubbleDots4: "icon-bubble-dots4",
        bubbleFirst: "icon-bubble-first",
        bubbleForward: "icon-bubble-forward",
        bubbleForward2: "icon-bubble-forward2",
        bubbleHeart: "icon-bubble-heart",
        bubbleLast: "icon-bubble-last",
        bubbleLeft: "icon-bubble-left",
        bubbleLines: "icon-bubble-lines",
        bubbleLines2: "icon-bubble-lines2",
        bubbleLines3: "icon-bubble-lines3",
        bubbleLines4: "icon-bubble-lines4",
        bubbleLink: "icon-bubble-link",
        bubbleLock: "icon-bubble-lock",
        bubbleMinus: "icon-bubble-minus",
        bubbleNotification: "icon-bubble-notification",
        bubbleNotification2: "icon-bubble-notification2",
        bubblePaperclip: "icon-bubble-paperclip",
        bubblePlus: "icon-bubble-plus",
        bubbleQuote: "icon-bubble-quote",
        bubbleReply: "icon-bubble-reply",
        bubbleReply2: "icon-bubble-reply2",
        bubbleRight: "icon-bubble-right",
        bubbleSmiley: "icon-bubble-smiley",
        bubbleStar: "icon-bubble-star",
        bubbleUser: "icon-bubble-user",
        bubbleVideo: "icon-bubble-video",
        bubble2: "icon-bubble2",
        bubble3: "icon-bubble3",
        bubble4: "icon-bubble4",
        bubble5: "icon-bubble5",
        bubble6: "icon-bubble6",
        bubble7: "icon-bubble7",
        bubble8: "icon-bubble8",
        bubble9: "icon-bubble9",
        bubbles: "icon-bubbles",
        bubbles10: "icon-bubbles10",
        bubbles2: "icon-bubbles2",
        bubbles3: "icon-bubbles3",
        bubbles4: "icon-bubbles4",
        bubbles5: "icon-bubbles5",
        bubbles6: "icon-bubbles6",
        bubbles7: "icon-bubbles7",
        bubbles8: "icon-bubbles8",
        bubbles9: "icon-bubbles9",
        bucket: "icon-bucket",
        bucket2: "icon-bucket2",
        bug: "icon-bug",
        bug2: "icon-bug2",
        bullhorn: "icon-bullhorn",
        bus: "icon-bus",
        cabinet: "icon-cabinet",
        cactus: "icon-cactus",
        cake: "icon-cake",
        calculator: "icon-calculator",
        calculator2: "icon-calculator2",
        calculator3: "icon-calculator3",
        calendar: "icon-calendar",
        calendar2: "icon-calendar2",
        calendar3: "icon-calendar3",
        calendar4: "icon-calendar4",
        calendar5: "icon-calendar5",
        camera: "icon-camera",
        camera2: "icon-camera2",
        camera3: "icon-camera3",
        cancel: "icon-cancel",
        cancelCircle: "icon-cancel-circle",
        cancelCircle2: "icon-cancel-circle2",
        cancelSquare: "icon-cancel-square",
        cancelSquare2: "icon-cancel-square2",
        car: "icon-car",
        car2: "icon-car2",
        cart: "icon-cart",
        cartAdd: "icon-cart-add",
        cartAdd2: "icon-cart-add2",
        cartRemove: "icon-cart-remove",
        cart2: "icon-cart2",
        cart3: "icon-cart3",
        cart4: "icon-cart4",
        cart5: "icon-cart5",
        cash: "icon-cash",
        cash2: "icon-cash2",
        cash3: "icon-cash3",
        cash4: "icon-cash4",
        cassette: "icon-cassette",
        cc: "icon-cc",
        certificate: "icon-certificate",
        chair: "icon-chair",
        chart: "icon-chart",
        checkboxChecked: "icon-checkbox-checked",
        checkboxChecked2: "icon-checkbox-checked2",
        checkboxPartial: "icon-checkbox-partial",
        checkboxPartial2: "icon-checkbox-partial2",
        checkboxUnchecked: "icon-checkbox-unchecked",
        checkboxUnchecked2: "icon-checkbox-unchecked2",
        checkmark: "icon-checkmark",
        checkmarkCircle: "icon-checkmark-circle",
        checkmark2: "icon-checkmark2",
        checkmark3: "icon-checkmark3",
        checkmark4: "icon-checkmark4",
        checkmark5: "icon-checkmark5",
        cheese: "icon-cheese",
        cherry: "icon-cherry",
        chess: "icon-chess",
        chessBishop: "icon-chess-bishop",
        chessKing: "icon-chess-king",
        chessKnight: "icon-chess-knight",
        chessPawn: "icon-chess-pawn",
        chessQueen: "icon-chess-queen",
        chessRock: "icon-chess-rock",
        chicken: "icon-chicken",
        chip: "icon-chip",
        chopper: "icon-chopper",
        chopper2: "icon-chopper2",
        chrome: "icon-chrome",
        circle: "icon-circle",
        circleCode: "icon-circle-code",
        circleCss: "icon-circle-css",
        circleDown: "icon-circle-down",
        circleDownLeft: "icon-circle-down-left",
        circleDownLeft2: "icon-circle-down-left2",
        circleDownRight: "icon-circle-down-right",
        circleDownRight2: "icon-circle-down-right2",
        circleDown2: "icon-circle-down2",
        circleDown3: "icon-circle-down3",
        circleDown4: "icon-circle-down4",
        circleDown5: "icon-circle-down5",
        circleDown6: "icon-circle-down6",
        circleLeft: "icon-circle-left",
        circleLeft2: "icon-circle-left2",
        circleLeft3: "icon-circle-left3",
        circleLeft4: "icon-circle-left4",
        circleLeft5: "icon-circle-left5",
        circleLeft6: "icon-circle-left6",
        circleRight: "icon-circle-right",
        circleRight2: "icon-circle-right2",
        circleRight3: "icon-circle-right3",
        circleRight4: "icon-circle-right4",
        circleRight5: "icon-circle-right5",
        circleRight6: "icon-circle-right6",
        circleSmall: "icon-circle-small",
        circleUp: "icon-circle-up",
        circleUpLeft: "icon-circle-up-left",
        circleUpLeft2: "icon-circle-up-left2",
        circleUpRight: "icon-circle-up-right",
        circleUpRight2: "icon-circle-up-right2",
        circleUp2: "icon-circle-up2",
        circleUp3: "icon-circle-up3",
        circleUp4: "icon-circle-up4",
        circleUp5: "icon-circle-up5",
        circleUp6: "icon-circle-up6",
        circle2: "icon-circle2",
        circles: "icon-circles",
        circles2: "icon-circles2",
        city: "icon-city",
        clapboard: "icon-clapboard",
        clapboardPlay: "icon-clapboard-play",
        clearFormatting: "icon-clear-formatting",
        clipboard: "icon-clipboard",
        clipboard2: "icon-clipboard2",
        clipboard3: "icon-clipboard3",
        clipboard4: "icon-clipboard4",
        clipboard5: "icon-clipboard5",
        clipboard6: "icon-clipboard6",
        clock: "icon-clock",
        clock2: "icon-clock2",
        clock3: "icon-clock3",
        clock4: "icon-clock4",
        cloud: "icon-cloud",
        cloudCheck: "icon-cloud-check",
        cloudCheck2: "icon-cloud-check2",
        cloudDownload: "icon-cloud-download",
        cloudDownload2: "icon-cloud-download2",
        cloudUpload: "icon-cloud-upload",
        cloudUpload2: "icon-cloud-upload2",
        cloud2: "icon-cloud2",
        clubs: "icon-clubs",
        code: "icon-code",
        codepen: "icon-codepen",
        coffee: "icon-coffee",
        coffeeBaen: "icon-coffee-baen",
        cog: "icon-cog",
        cog2: "icon-cog2",
        cog3: "icon-cog3",
        cog4: "icon-cog4",
        cog5: "icon-cog5",
        cog6: "icon-cog6",
        cog7: "icon-cog7",
        cogs: "icon-cogs",
        coinDollar: "icon-coin-dollar",
        coinEuro: "icon-coin-euro",
        coinPound: "icon-coin-pound",
        coinYen: "icon-coin-yen",
        coins: "icon-coins",
        collaboration: "icon-collaboration",
        colorClear: "icon-color-clear",
        colorSampler: "icon-color-sampler",
        comb: "icon-comb",
        command: "icon-command",
        compass: "icon-compass",
        compass2: "icon-compass2",
        compass3: "icon-compass3",
        compass4: "icon-compass4",
        compass5: "icon-compass5",
        compass6: "icon-compass6",
        confused: "icon-confused",
        confused2: "icon-confused2",
        connection: "icon-connection",
        connection2: "icon-connection2",
        connection3: "icon-connection3",
        connection4: "icon-connection4",
        construction: "icon-construction",
        contrast: "icon-contrast",
        cook: "icon-cook",
        cool: "icon-cool",
        cool2: "icon-cool2",
        copy: "icon-copy",
        copy2: "icon-copy2",
        copy3: "icon-copy3",
        copy4: "icon-copy4",
        creditCard: "icon-credit-card",
        creditCard2: "icon-credit-card2",
        crop: "icon-crop",
        crop2: "icon-crop2",
        cross: "icon-cross",
        cross2: "icon-cross2",
        cross3: "icon-cross3",
        crown: "icon-crown",
        crying: "icon-crying",
        crying2: "icon-crying2",
        css3: "icon-css3",
        ctrl: "icon-ctrl",
        cube: "icon-cube",
        cube2: "icon-cube2",
        cube3: "icon-cube3",
        cube4: "icon-cube4",
        cup: "icon-cup",
        cup2: "icon-cup2",
        cursor: "icon-cursor",
        cursor2: "icon-cursor2",
        database: "icon-database",
        databaseAdd: "icon-database-add",
        databaseArrow: "icon-database-arrow",
        databaseCheck: "icon-database-check",
        databaseDiff: "icon-database-diff",
        databaseEdit: "icon-database-edit",
        databaseEdit2: "icon-database-edit2",
        databaseExport: "icon-database-export",
        databaseInsert: "icon-database-insert",
        databaseMenu: "icon-database-menu",
        databaseRefresh: "icon-database-refresh",
        databaseRemove: "icon-database-remove",
        databaseTime: "icon-database-time",
        databaseTime2: "icon-database-time2",
        databaseUpload: "icon-database-upload",
        database2: "icon-database2",
        database3: "icon-database3",
        database4: "icon-database4",
        dayNight: "icon-day-night",
        dayNight2: "icon-day-night2",
        delicious: "icon-delicious",
        design: "icon-design",
        deviantart: "icon-deviantart",
        deviantart2: "icon-deviantart2",
        diamond: "icon-diamond",
        diamond2: "icon-diamond2",
        diamond3: "icon-diamond3",
        diamond4: "icon-diamond4",
        diamonds: "icon-diamonds",
        dice: "icon-dice",
        direction: "icon-direction",
        disk: "icon-disk",
        disk2: "icon-disk2",
        display: "icon-display",
        display2: "icon-display2",
        display3: "icon-display3",
        display4: "icon-display4",
        dots: "icon-dots",
        download: "icon-download",
        download10: "icon-download10",
        download2: "icon-download2",
        download3: "icon-download3",
        download4: "icon-download4",
        download5: "icon-download5",
        download6: "icon-download6",
        download7: "icon-download7",
        download8: "icon-download8",
        download9: "icon-download9",
        dragLeft: "icon-drag-left",
        dragLeftRight: "icon-drag-left-right",
        dragRight: "icon-drag-right",
        drawer: "icon-drawer",
        drawerIn: "icon-drawer-in",
        drawerOut: "icon-drawer-out",
        drawer2: "icon-drawer2",
        drawer3: "icon-drawer3",
        dribbble: "icon-dribbble",
        dribbble2: "icon-dribbble2",
        dribbble3: "icon-dribbble3",
        drive: "icon-drive",
        dropbox: "icon-dropbox",
        droplet: "icon-droplet",
        dropletContrast: "icon-droplet-contrast",
        droplet2: "icon-droplet2",
        dumbbell: "icon-dumbbell",
        earth: "icon-earth",
        earth2: "icon-earth2",
        earth3: "icon-earth3",
        eightBall: "icon-eight-ball",
        eject: "icon-eject",
        ello: "icon-ello",
        embed: "icon-embed",
        embed2: "icon-embed2",
        enlarge: "icon-enlarge",
        enlarge2: "icon-enlarge2",
        enlarge3: "icon-enlarge3",
        enlarge4: "icon-enlarge4",
        enlarge5: "icon-enlarge5",
        enlarge6: "icon-enlarge6",
        enlarge7: "icon-enlarge7",
        enter: "icon-enter",
        enter2: "icon-enter2",
        enter3: "icon-enter3",
        enter4: "icon-enter4",
        enter5: "icon-enter5",
        enter6: "icon-enter6",
        envelop: "icon-envelop",
        envelop2: "icon-envelop2",
        envelop3: "icon-envelop3",
        envelop4: "icon-envelop4",
        envelop5: "icon-envelop5",
        equalizer: "icon-equalizer",
        equalizer2: "icon-equalizer2",
        equalizer3: "icon-equalizer3",
        equalizer4: "icon-equalizer4",
        eraser: "icon-eraser",
        eraser2: "icon-eraser2",
        eraser3: "icon-eraser3",
        esc: "icon-esc",
        evil: "icon-evil",
        evil2: "icon-evil2",
        exclude: "icon-exclude",
        exit: "icon-exit",
        exit2: "icon-exit2",
        exit3: "icon-exit3",
        eye: "icon-eye",
        eyeBlocked: "icon-eye-blocked",
        eyeBlocked2: "icon-eye-blocked2",
        eyeBlocked3: "icon-eye-blocked3",
        eyeMinus: "icon-eye-minus",
        eyePlus: "icon-eye-plus",
        eye2: "icon-eye2",
        eye3: "icon-eye3",
        eye4: "icon-eye4",
        eyedropper: "icon-eyedropper",
        eyedropper2: "icon-eyedropper2",
        eyedropper3: "icon-eyedropper3",
        facebook: "icon-facebook",
        facebook2: "icon-facebook2",
        facebook3: "icon-facebook3",
        factory: "icon-factory",
        fan: "icon-fan",
        feed: "icon-feed",
        feed2: "icon-feed2",
        feed3: "icon-feed3",
        feed4: "icon-feed4",
        female: "icon-female",
        fence: "icon-fence",
        fileCheck: "icon-file-check",
        fileCheck2: "icon-file-check2",
        fileCss: "icon-file-css",
        fileCss2: "icon-file-css2",
        fileDownload: "icon-file-download",
        fileDownload2: "icon-file-download2",
        fileEmpty: "icon-file-empty",
        fileEmpty2: "icon-file-empty2",
        fileExcel: "icon-file-excel",
        fileEye: "icon-file-eye",
        fileEye2: "icon-file-eye2",
        fileLocked: "icon-file-locked",
        fileLocked2: "icon-file-locked2",
        fileMinus: "icon-file-minus",
        fileMinus2: "icon-file-minus2",
        fileMusic: "icon-file-music",
        fileMusic2: "icon-file-music2",
        fileOpenoffice: "icon-file-openoffice",
        filePdf: "icon-file-pdf",
        filePicture: "icon-file-picture",
        filePicture2: "icon-file-picture2",
        filePlay: "icon-file-play",
        filePlay2: "icon-file-play2",
        filePlus: "icon-file-plus",
        filePlus2: "icon-file-plus2",
        filePresentation: "icon-file-presentation",
        filePresentation2: "icon-file-presentation2",
        fileSpreadsheet: "icon-file-spreadsheet",
        fileSpreadsheet2: "icon-file-spreadsheet2",
        fileStats: "icon-file-stats",
        fileStats2: "icon-file-stats2",
        fileText: "icon-file-text",
        fileText2: "icon-file-text2",
        fileText3: "icon-file-text3",
        fileUpload: "icon-file-upload",
        fileUpload2: "icon-file-upload2",
        fileVideo: "icon-file-video",
        fileVideo2: "icon-file-video2",
        fileWord: "icon-file-word",
        fileXml: "icon-file-xml",
        fileXml2: "icon-file-xml2",
        fileZip: "icon-file-zip",
        fileZip2: "icon-file-zip2",
        filesEmpty: "icon-files-empty",
        filesEmpty2: "icon-files-empty2",
        film: "icon-film",
        film2: "icon-film2",
        film3: "icon-film3",
        film4: "icon-film4",
        filter: "icon-filter",
        filter2: "icon-filter2",
        filter3: "icon-filter3",
        filter4: "icon-filter4",
        finder: "icon-finder",
        finish: "icon-finish",
        fire: "icon-fire",
        fire2: "icon-fire2",
        firefox: "icon-firefox",
        first: "icon-first",
        first2: "icon-first2",
        fish: "icon-fish",
        flag: "icon-flag",
        flag2: "icon-flag2",
        flag3: "icon-flag3",
        flag4: "icon-flag4",
        flag5: "icon-flag5",
        flag6: "icon-flag6",
        flag7: "icon-flag7",
        flag8: "icon-flag8",
        flattr: "icon-flattr",
        flickr: "icon-flickr",
        flickr2: "icon-flickr2",
        flickr3: "icon-flickr3",
        flickr4: "icon-flickr4",
        flipHorizontal: "icon-flip-horizontal",
        flipHorizontal2: "icon-flip-horizontal2",
        flipVertical: "icon-flip-vertical",
        flipVertical2: "icon-flip-vertical2",
        flipVertical3: "icon-flip-vertical3",
        flipVertical4: "icon-flip-vertical4",
        floppyDisk: "icon-floppy-disk",
        floppyDisk2: "icon-floppy-disk2",
        floppyDisk3: "icon-floppy-disk3",
        floppyDisks: "icon-floppy-disks",
        floppyDisks2: "icon-floppy-disks2",
        flower: "icon-flower",
        flower2: "icon-flower2",
        folder: "icon-folder",
        folderCheck: "icon-folder-check",
        folderDownload: "icon-folder-download",
        folderDownload2: "icon-folder-download2",
        folderDownload3: "icon-folder-download3",
        folderHeart: "icon-folder-heart",
        folderMinus: "icon-folder-minus",
        folderMinus2: "icon-folder-minus2",
        folderMinus3: "icon-folder-minus3",
        folderMinus4: "icon-folder-minus4",
        folderOpen: "icon-folder-open",
        folderOpen2: "icon-folder-open2",
        folderOpen3: "icon-folder-open3",
        folderPlus: "icon-folder-plus",
        folderPlus2: "icon-folder-plus2",
        folderPlus3: "icon-folder-plus3",
        folderPlus4: "icon-folder-plus4",
        folderRemove: "icon-folder-remove",
        folderSearch: "icon-folder-search",
        folderUpload: "icon-folder-upload",
        folderUpload2: "icon-folder-upload2",
        folderUpload3: "icon-folder-upload3",
        folder2: "icon-folder2",
        folder3: "icon-folder3",
        folder4: "icon-folder4",
        folder5: "icon-folder5",
        folder6: "icon-folder6",
        font: "icon-font",
        fontSize: "icon-font-size",
        fontSize2: "icon-font-size2",
        football: "icon-football",
        footprint: "icon-footprint",
        forkKnife: "icon-fork-knife",
        forrst: "icon-forrst",
        forrst2: "icon-forrst2",
        forward: "icon-forward",
        forward2: "icon-forward2",
        forward3: "icon-forward3",
        foursquare: "icon-foursquare",
        frustrated: "icon-frustrated",
        frustrated2: "icon-frustrated2",
        furniture: "icon-furniture",
        gamepad: "icon-gamepad",
        gamepad2: "icon-gamepad2",
        gamepad3: "icon-gamepad3",
        gas: "icon-gas",
        gift: "icon-gift",
        gift2: "icon-gift2",
        git: "icon-git",
        github: "icon-github",
        github2: "icon-github2",
        github3: "icon-github3",
        github4: "icon-github4",
        github5: "icon-github5",
        glass: "icon-glass",
        glass2: "icon-glass2",
        glass3: "icon-glass3",
        glass4: "icon-glass4",
        glasses: "icon-glasses",
        glasses3d: "icon-glasses-3d",
        glasses3d2: "icon-glasses-3d2",
        glasses2: "icon-glasses2",
        golf: "icon-golf",
        golf2: "icon-golf2",
        google: "icon-google",
        googleDrive: "icon-google-drive",
        googlePlus: "icon-google-plus",
        googlePlus2: "icon-google-plus2",
        googlePlus3: "icon-google-plus3",
        grab: "icon-grab",
        gradient: "icon-gradient",
        graduation: "icon-graduation",
        grapes: "icon-grapes",
        grid: "icon-grid",
        grid2: "icon-grid2",
        grid3: "icon-grid3",
        grid4: "icon-grid4",
        grid5: "icon-grid5",
        grid6: "icon-grid6",
        grid7: "icon-grid7",
        grin: "icon-grin",
        grin2: "icon-grin2",
        guitar: "icon-guitar",
        gun: "icon-gun",
        gunForbidden: "icon-gun-forbidden",
        haircut: "icon-haircut",
        hamburger: "icon-hamburger",
        hammer: "icon-hammer",
        hammerWrench: "icon-hammer-wrench",
        hammer2: "icon-hammer2",
        hand: "icon-hand",
        hanger: "icon-hanger",
        happy: "icon-happy",
        happy2: "icon-happy2",
        hat: "icon-hat",
        headphones: "icon-headphones",
        headset: "icon-headset",
        heart: "icon-heart",
        heartBroken: "icon-heart-broken",
        heartBroken2: "icon-heart-broken2",
        heartBroken3: "icon-heart-broken3",
        heart2: "icon-heart2",
        heart3: "icon-heart3",
        heart4: "icon-heart4",
        heart5: "icon-heart5",
        heart6: "icon-heart6",
        heart7: "icon-heart7",
        heart8: "icon-heart8",
        height: "icon-height",
        height2: "icon-height2",
        highlight: "icon-highlight",
        hipster: "icon-hipster",
        hipster2: "icon-hipster2",
        history: "icon-history",
        hockey: "icon-hockey",
        home: "icon-home",
        home2: "icon-home2",
        home3: "icon-home3",
        home4: "icon-home4",
        home5: "icon-home5",
        home6: "icon-home6",
        home7: "icon-home7",
        home8: "icon-home8",
        home9: "icon-home9",
        hourGlass: "icon-hour-glass",
        hourGlass2: "icon-hour-glass2",
        hourGlass3: "icon-hour-glass3",
        html5: "icon-html5",
        html52: "icon-html52",
        icecream: "icon-icecream",
        icoMoon: "icon-IcoMoon",
        iE: "icon-IE",
        image: "icon-image",
        imageCompare: "icon-image-compare",
        image2: "icon-image2",
        image3: "icon-image3",
        image4: "icon-image4",
        image5: "icon-image5",
        image6: "icon-image6",
        images: "icon-images",
        images2: "icon-images2",
        images3: "icon-images3",
        import: "icon-import",
        import2: "icon-import2",
        indentDecrease: "icon-indent-decrease",
        indentDecrease2: "icon-indent-decrease2",
        indentIncrease: "icon-indent-increase",
        indentIncrease2: "icon-indent-increase2",
        infinite: "icon-infinite",
        infiniteSquare: "icon-infinite-square",
        infinite2: "icon-infinite2",
        info: "icon-info",
        info2: "icon-info2",
        insertTemplate: "icon-insert-template",
        instagram: "icon-instagram",
        interset: "icon-interset",
        italic: "icon-italic",
        italic2: "icon-italic2",
        joomla: "icon-joomla",
        key: "icon-key",
        keyA: "icon-key-A",
        keyDown: "icon-key-down",
        keyKeyboard: "icon-key-keyboard",
        keyLeft: "icon-key-left",
        keyRight: "icon-key-right",
        keyUp: "icon-key-up",
        key2: "icon-key2",
        key3: "icon-key3",
        key4: "icon-key4",
        key5: "icon-key5",
        keyboard: "icon-keyboard",
        keyboard2: "icon-keyboard2",
        keyhole: "icon-keyhole",
        knife: "icon-knife",
        lab: "icon-lab",
        ladder: "icon-ladder",
        lamp: "icon-lamp",
        lamp2: "icon-lamp2",
        lamp3: "icon-lamp3",
        lamp4: "icon-lamp4",
        lamp5: "icon-lamp5",
        lamp6: "icon-lamp6",
        lamp7: "icon-lamp7",
        lamp8: "icon-lamp8",
        lan: "icon-lan",
        lan2: "icon-lan2",
        lan3: "icon-lan3",
        lanyrd: "icon-lanyrd",
        laptop: "icon-laptop",
        lasso: "icon-lasso",
        lasso2: "icon-lasso2",
        last: "icon-last",
        last2: "icon-last2",
        lastfm: "icon-lastfm",
        lastfm2: "icon-lastfm2",
        laundry: "icon-laundry",
        leaf: "icon-leaf",
        leaf2: "icon-leaf2",
        library: "icon-library",
        library2: "icon-library2",
        libreoffice: "icon-libreoffice",
        lifebuoy: "icon-lifebuoy",
        ligature: "icon-ligature",
        ligature2: "icon-ligature2",
        link: "icon-link",
        link2: "icon-link2",
        link3: "icon-link3",
        link4: "icon-link4",
        link5: "icon-link5",
        linkedin: "icon-linkedin",
        linkedin2: "icon-linkedin2",
        lips: "icon-lips",
        lips2: "icon-lips2",
        list: "icon-list",
        listNumbered: "icon-list-numbered",
        list2: "icon-list2",
        location: "icon-location",
        location2: "icon-location2",
        location3: "icon-location3",
        location4: "icon-location4",
        location5: "icon-location5",
        location6: "icon-location6",
        location7: "icon-location7",
        lock: "icon-lock",
        lock2: "icon-lock2",
        lock3: "icon-lock3",
        lock4: "icon-lock4",
        lock5: "icon-lock5",
        loop: "icon-loop",
        loop2: "icon-loop2",
        loop3: "icon-loop3",
        loop4: "icon-loop4",
        ltr: "icon-ltr",
        ltr2: "icon-ltr2",
        magazine: "icon-magazine",
        magicWand: "icon-magic-wand",
        magicWand2: "icon-magic-wand2",
        magnet: "icon-magnet",
        magnet2: "icon-magnet2",
        mail: "icon-mail",
        mail2: "icon-mail2",
        mail3: "icon-mail3",
        mail4: "icon-mail4",
        mailbox: "icon-mailbox",
        makeGroup: "icon-make-group",
        male: "icon-male",
        man: "icon-man",
        manWoman: "icon-man-woman",
        map: "icon-map",
        map2: "icon-map2",
        map3: "icon-map3",
        map4: "icon-map4",
        map5: "icon-map5",
        marker: "icon-marker",
        marker2: "icon-marker2",
        markup: "icon-markup",
        medal: "icon-medal",
        medalFirst: "icon-medal-first",
        medalSecond: "icon-medal-second",
        medalStar: "icon-medal-star",
        medalThird: "icon-medal-third",
        medal2: "icon-medal2",
        media: "icon-media",
        megaphone: "icon-megaphone",
        menu: "icon-menu",
        menuClose: "icon-menu-close",
        menuClose2: "icon-menu-close2",
        menuOpen: "icon-menu-open",
        menuOpen2: "icon-menu-open2",
        menu10: "icon-menu10",
        menu2: "icon-menu2",
        menu3: "icon-menu3",
        menu4: "icon-menu4",
        menu5: "icon-menu5",
        menu6: "icon-menu6",
        menu7: "icon-menu7",
        menu8: "icon-menu8",
        menu9: "icon-menu9",
        merge: "icon-merge",
        meter: "icon-meter",
        meterFast: "icon-meter-fast",
        meterMedium: "icon-meter-medium",
        meterSlow: "icon-meter-slow",
        meter2: "icon-meter2",
        meter3: "icon-meter3",
        mic: "icon-mic",
        micOff: "icon-mic-off",
        micOff2: "icon-mic-off2",
        mic2: "icon-mic2",
        mic3: "icon-mic3",
        mic4: "icon-mic4",
        mic5: "icon-mic5",
        microscope: "icon-microscope",
        milk: "icon-milk",
        minus: "icon-minus",
        minusCircle: "icon-minus-circle",
        minusCircle2: "icon-minus-circle2",
        minus2: "icon-minus2",
        minus3: "icon-minus3",
        mobile: "icon-mobile",
        mobile2: "icon-mobile2",
        mobile3: "icon-mobile3",
        moon: "icon-moon",
        more: "icon-more",
        more2: "icon-more2",
        mountains: "icon-mountains",
        mouse: "icon-mouse",
        mouseLeft: "icon-mouse-left",
        mouseRight: "icon-mouse-right",
        mouse2: "icon-mouse2",
        move: "icon-move",
        moveDown: "icon-move-down",
        moveUp: "icon-move-up",
        movie: "icon-movie",
        mug: "icon-mug",
        multitouch: "icon-multitouch",
        music: "icon-music",
        music2: "icon-music2",
        music3: "icon-music3",
        music4: "icon-music4",
        music5: "icon-music5",
        music6: "icon-music6",
        mustache: "icon-mustache",
        mustache2: "icon-mustache2",
        nbsp: "icon-nbsp",
        neutral: "icon-neutral",
        neutral2: "icon-neutral2",
        new: "icon-new",
        newTab: "icon-new-tab",
        newTab2: "icon-new-tab2",
        newspaper: "icon-newspaper",
        next: "icon-next",
        next2: "icon-next2",
        notebook: "icon-notebook",
        notification: "icon-notification",
        notification2: "icon-notification2",
        office: "icon-office",
        omega: "icon-omega",
        onedrive: "icon-onedrive",
        opera: "icon-opera",
        opt: "icon-opt",
        outlet: "icon-outlet",
        package: "icon-package",
        pacman: "icon-pacman",
        pageBreak: "icon-page-break",
        pageBreak2: "icon-page-break2",
        pagebreak: "icon-pagebreak",
        paintFormat: "icon-paint-format",
        palette: "icon-palette",
        palette2: "icon-palette2",
        pandage: "icon-pandage",
        pandage2: "icon-pandage2",
        pants: "icon-pants",
        paperplane: "icon-paperplane",
        paragraphCenter: "icon-paragraph-center",
        paragraphCenter2: "icon-paragraph-center2",
        paragraphCenter3: "icon-paragraph-center3",
        paragraphJustify: "icon-paragraph-justify",
        paragraphJustify2: "icon-paragraph-justify2",
        paragraphJustify3: "icon-paragraph-justify3",
        paragraphLeft: "icon-paragraph-left",
        paragraphLeft2: "icon-paragraph-left2",
        paragraphLeft3: "icon-paragraph-left3",
        paragraphRight: "icon-paragraph-right",
        paragraphRight2: "icon-paragraph-right2",
        paragraphRight3: "icon-paragraph-right3",
        paste: "icon-paste",
        paste2: "icon-paste2",
        paste3: "icon-paste3",
        paste4: "icon-paste4",
        pause: "icon-pause",
        pause2: "icon-pause2",
        paw: "icon-paw",
        paypal: "icon-paypal",
        paypal2: "icon-paypal2",
        paypal3: "icon-paypal3",
        peace: "icon-peace",
        pen: "icon-pen",
        penMinus: "icon-pen-minus",
        penPlus: "icon-pen-plus",
        pen2: "icon-pen2",
        pen3: "icon-pen3",
        pen4: "icon-pen4",
        pen5: "icon-pen5",
        pen6: "icon-pen6",
        pencil: "icon-pencil",
        pencilRuler: "icon-pencil-ruler",
        pencil2: "icon-pencil2",
        pencil3: "icon-pencil3",
        pencil4: "icon-pencil4",
        pencil5: "icon-pencil5",
        pencil6: "icon-pencil6",
        pencil7: "icon-pencil7",
        percent: "icon-percent",
        phone: "icon-phone",
        phoneHangUp: "icon-phone-hang-up",
        phoneHangUp2: "icon-phone-hang-up2",
        phoneIncoming: "icon-phone-incoming",
        phoneMinus: "icon-phone-minus",
        phoneMinus2: "icon-phone-minus2",
        phoneOutgoing: "icon-phone-outgoing",
        phonePlus: "icon-phone-plus",
        phonePlus2: "icon-phone-plus2",
        phoneSlash: "icon-phone-slash",
        phoneSlash2: "icon-phone-slash2",
        phoneWave: "icon-phone-wave",
        phoneWave2: "icon-phone-wave2",
        phone2: "icon-phone2",
        phone3: "icon-phone3",
        piano: "icon-piano",
        picassa: "icon-picassa",
        picassa2: "icon-picassa2",
        pieChart: "icon-pie-chart",
        pieChart2: "icon-pie-chart2",
        pieChart3: "icon-pie-chart3",
        pieChart4: "icon-pie-chart4",
        pieChart5: "icon-pie-chart5",
        pieChart6: "icon-pie-chart6",
        pieChart7: "icon-pie-chart7",
        pieChart8: "icon-pie-chart8",
        piggyBank: "icon-piggy-bank",
        pilcrow: "icon-pilcrow",
        pill: "icon-pill",
        pingpong: "icon-pingpong",
        pinterest: "icon-pinterest",
        pinterest2: "icon-pinterest2",
        pipe: "icon-pipe",
        pizza: "icon-pizza",
        planet: "icon-planet",
        planet2: "icon-planet2",
        plate: "icon-plate",
        play: "icon-play",
        play2: "icon-play2",
        play3: "icon-play3",
        play4: "icon-play4",
        playlist: "icon-playlist",
        playlistAdd: "icon-playlist-add",
        plus: "icon-plus",
        plusCircle: "icon-plus-circle",
        plusCircle2: "icon-plus-circle2",
        plus2: "icon-plus2",
        plus3: "icon-plus3",
        podcast: "icon-podcast",
        podcast2: "icon-podcast2",
        podium: "icon-podium",
        pointDown: "icon-point-down",
        pointLeft: "icon-point-left",
        pointRight: "icon-point-right",
        pointUp: "icon-point-up",
        pointer: "icon-pointer",
        popout: "icon-popout",
        power: "icon-power",
        powerCord: "icon-power-cord",
        powerCord2: "icon-power-cord2",
        power2: "icon-power2",
        power3: "icon-power3",
        presentation: "icon-presentation",
        previous: "icon-previous",
        previous2: "icon-previous2",
        priceTag: "icon-price-tag",
        priceTag2: "icon-price-tag2",
        priceTag3: "icon-price-tag3",
        priceTag4: "icon-price-tag4",
        priceTag5: "icon-price-tag5",
        priceTags: "icon-price-tags",
        priceTags2: "icon-price-tags2",
        priceTags3: "icon-price-tags3",
        priceTags4: "icon-price-tags4",
        printer: "icon-printer",
        printer2: "icon-printer2",
        printer3: "icon-printer3",
        printer4: "icon-printer4",
        profile: "icon-profile",
        pulse: "icon-pulse",
        pulse2: "icon-pulse2",
        pushpin: "icon-pushpin",
        pushpin2: "icon-pushpin2",
        puzzle: "icon-puzzle",
        puzzle2: "icon-puzzle2",
        puzzle3: "icon-puzzle3",
        puzzle4: "icon-puzzle4",
        pyramid: "icon-pyramid",
        pyramid2: "icon-pyramid2",
        qrcode: "icon-qrcode",
        question: "icon-question",
        question2: "icon-question2",
        question3: "icon-question3",
        question4: "icon-question4",
        question5: "icon-question5",
        question6: "icon-question6",
        quill: "icon-quill",
        quill2: "icon-quill2",
        quill3: "icon-quill3",
        quill4: "icon-quill4",
        quotesLeft: "icon-quotes-left",
        quotesLeft2: "icon-quotes-left2",
        quotesRight: "icon-quotes-right",
        quotesRight2: "icon-quotes-right2",
        racing: "icon-racing",
        radio: "icon-radio",
        radioChecked: "icon-radio-checked",
        radioChecked2: "icon-radio-checked2",
        radioUnchecked: "icon-radio-unchecked",
        rating: "icon-rating",
        rating2: "icon-rating2",
        rating3: "icon-rating3",
        reading: "icon-reading",
        recording: "icon-recording",
        reddit: "icon-reddit",
        redo: "icon-redo",
        redo2: "icon-redo2",
        regexp: "icon-regexp",
        regexp2: "icon-regexp2",
        reminder: "icon-reminder",
        reply: "icon-reply",
        replyAll: "icon-reply-all",
        reset: "icon-reset",
        road: "icon-road",
        rocket: "icon-rocket",
        rotateCcw: "icon-rotate-ccw",
        rotateCcw2: "icon-rotate-ccw2",
        rotateCcw3: "icon-rotate-ccw3",
        rotateCw: "icon-rotate-cw",
        rotateCw2: "icon-rotate-cw2",
        rotateCw3: "icon-rotate-cw3",
        rtl: "icon-rtl",
        rtl2: "icon-rtl2",
        ruler: "icon-ruler",
        rulers: "icon-rulers",
        sad: "icon-sad",
        sad2: "icon-sad2",
        safari: "icon-safari",
        safe: "icon-safe",
        satelliteDish: "icon-satellite-dish",
        satelliteDish2: "icon-satellite-dish2",
        scale: "icon-scale",
        scissors: "icon-scissors",
        scissors2: "icon-scissors2",
        scissors3: "icon-scissors3",
        screwdriver: "icon-screwdriver",
        screwdriver2: "icon-screwdriver2",
        search: "icon-search",
        search2: "icon-search2",
        search3: "icon-search3",
        search4: "icon-search4",
        search5: "icon-search5",
        search6: "icon-search6",
        section: "icon-section",
        select: "icon-select",
        select2: "icon-select2",
        server: "icon-server",
        sevenSegment0: "icon-seven-segment-0",
        sevenSegment1: "icon-seven-segment-1",
        sevenSegment2: "icon-seven-segment-2",
        sevenSegment3: "icon-seven-segment-3",
        sevenSegment4: "icon-seven-segment-4",
        sevenSegment5: "icon-seven-segment-5",
        sevenSegment6: "icon-seven-segment-6",
        sevenSegment7: "icon-seven-segment-7",
        sevenSegment8: "icon-seven-segment-8",
        sevenSegment9: "icon-seven-segment-9",
        share: "icon-share",
        share2: "icon-share2",
        share3: "icon-share3",
        share4: "icon-share4",
        shear: "icon-shear",
        shield: "icon-shield",
        shieldCheck: "icon-shield-check",
        shieldNotice: "icon-shield-notice",
        shield2: "icon-shield2",
        shield3: "icon-shield3",
        shield4: "icon-shield4",
        shift: "icon-shift",
        ship: "icon-ship",
        shocked: "icon-shocked",
        shocked2: "icon-shocked2",
        shorts: "icon-shorts",
        shredder: "icon-shredder",
        shrink: "icon-shrink",
        shrink2: "icon-shrink2",
        shrink3: "icon-shrink3",
        shrink4: "icon-shrink4",
        shrink5: "icon-shrink5",
        shrink6: "icon-shrink6",
        shrink7: "icon-shrink7",
        shuffle: "icon-shuffle",
        shuffle2: "icon-shuffle2",
        shutter: "icon-shutter",
        sigma: "icon-sigma",
        skull: "icon-skull",
        skull2: "icon-skull2",
        skype: "icon-skype",
        sleepy: "icon-sleepy",
        sleepy2: "icon-sleepy2",
        smile: "icon-smile",
        smile2: "icon-smile2",
        snowflake: "icon-snowflake",
        soccer: "icon-soccer",
        sock: "icon-sock",
        sort: "icon-sort",
        sortAlphaAsc: "icon-sort-alpha-asc",
        sortAlphaDesc: "icon-sort-alpha-desc",
        sortAmountAsc: "icon-sort-amount-asc",
        sortAmountDesc: "icon-sort-amount-desc",
        sortNumbericDesc: "icon-sort-numberic-desc",
        sortNumericAsc: "icon-sort-numeric-asc",
        sortTimeAsc: "icon-sort-time-asc",
        sortTimeDesc: "icon-sort-time-desc",
        sort2: "icon-sort2",
        soundcloud: "icon-soundcloud",
        soundcloud2: "icon-soundcloud2",
        spades: "icon-spades",
        spam: "icon-spam",
        speakerLeft: "icon-speaker-left",
        speakerRight: "icon-speaker-right",
        speakers: "icon-speakers",
        spellCheck: "icon-spell-check",
        spellCheck2: "icon-spell-check2",
        sphere: "icon-sphere",
        sphere2: "icon-sphere2",
        sphere3: "icon-sphere3",
        spinner: "icon-spinner",
        spinner10: "icon-spinner10",
        spinner11: "icon-spinner11",
        spinner2: "icon-spinner2",
        spinner3: "icon-spinner3",
        spinner4: "icon-spinner4",
        spinner5: "icon-spinner5",
        spinner6: "icon-spinner6",
        spinner7: "icon-spinner7",
        spinner8: "icon-spinner8",
        spinner9: "icon-spinner9",
        split: "icon-split",
        spoonKnife: "icon-spoon-knife",
        spotlight: "icon-spotlight",
        spotlight2: "icon-spotlight2",
        spray: "icon-spray",
        square: "icon-square",
        squareDown: "icon-square-down",
        squareDownLeft: "icon-square-down-left",
        squareDownRight: "icon-square-down-right",
        squareLeft: "icon-square-left",
        squareRight: "icon-square-right",
        squareUp: "icon-square-up",
        squareUpLeft: "icon-square-up-left",
        squareUpRight: "icon-square-up-right",
        stack: "icon-stack",
        stackCancel: "icon-stack-cancel",
        stackCheck: "icon-stack-check",
        stackClubs: "icon-stack-clubs",
        stackDiamonds: "icon-stack-diamonds",
        stackDown: "icon-stack-down",
        stackEmpty: "icon-stack-empty",
        stackHearts: "icon-stack-hearts",
        stackMinus: "icon-stack-minus",
        stackMusic: "icon-stack-music",
        stackPicture: "icon-stack-picture",
        stackPlay: "icon-stack-play",
        stackPlus: "icon-stack-plus",
        stackSpades: "icon-stack-spades",
        stackStar: "icon-stack-star",
        stackText: "icon-stack-text",
        stackUp: "icon-stack-up",
        stackUser: "icon-stack-user",
        stack2: "icon-stack2",
        stack3: "icon-stack3",
        stack4: "icon-stack4",
        stackoverflow: "icon-stackoverflow",
        stairs: "icon-stairs",
        stairsDown: "icon-stairs-down",
        stairsUp: "icon-stairs-up",
        stairs2: "icon-stairs2",
        stamp: "icon-stamp",
        star: "icon-star",
        starEmpty: "icon-star-empty",
        starEmpty2: "icon-star-empty2",
        starEmpty3: "icon-star-empty3",
        starFull: "icon-star-full",
        starFull2: "icon-star-full2",
        starHalf: "icon-star-half",
        starburst: "icon-starburst",
        stars: "icon-stars",
        station: "icon-station",
        station2: "icon-station2",
        statsBars: "icon-stats-bars",
        statsBars2: "icon-stats-bars2",
        statsBars3: "icon-stats-bars3",
        statsBars4: "icon-stats-bars4",
        statsBars5: "icon-stats-bars5",
        statsBars6: "icon-stats-bars6",
        statsDecline: "icon-stats-decline",
        statsDecline2: "icon-stats-decline2",
        statsDots: "icon-stats-dots",
        statsGrowth: "icon-stats-growth",
        statsGrowth2: "icon-stats-growth2",
        steak: "icon-steak",
        steam: "icon-steam",
        steam2: "icon-steam2",
        steeringWheel: "icon-steering-wheel",
        stethoscope: "icon-stethoscope",
        stop: "icon-stop",
        stop2: "icon-stop2",
        stopwatch: "icon-stopwatch",
        store: "icon-store",
        store2: "icon-store2",
        strategy: "icon-strategy",
        strikethrough: "icon-strikethrough",
        strikethrough2: "icon-strikethrough2",
        strikethrough3: "icon-strikethrough3",
        stumbleupon: "icon-stumbleupon",
        stumbleupon2: "icon-stumbleupon2",
        subscript: "icon-subscript",
        subscript2: "icon-subscript2",
        subtract: "icon-subtract",
        sun: "icon-sun",
        sun2: "icon-sun2",
        sun3: "icon-sun3",
        superscript: "icon-superscript",
        superscript2: "icon-superscript2",
        svg: "icon-svg",
        switch: "icon-switch",
        switch2: "icon-switch2",
        sword: "icon-sword",
        syringe: "icon-syringe",
        syringe2: "icon-syringe2",
        tab: "icon-tab",
        table: "icon-table",
        table2: "icon-table2",
        tablet: "icon-tablet",
        tape: "icon-tape",
        target: "icon-target",
        target2: "icon-target2",
        target3: "icon-target3",
        teapot: "icon-teapot",
        temperature: "icon-temperature",
        temperature2: "icon-temperature2",
        tennis: "icon-tennis",
        tent: "icon-tent",
        terminal: "icon-terminal",
        textColor: "icon-text-color",
        textHeight: "icon-text-height",
        textWidth: "icon-text-width",
        theater: "icon-theater",
        thumbsDown: "icon-thumbs-down",
        thumbsDown2: "icon-thumbs-down2",
        thumbsDown3: "icon-thumbs-down3",
        thumbsUp: "icon-thumbs-up",
        thumbsUp2: "icon-thumbs-up2",
        thumbsUp3: "icon-thumbs-up3",
        ticket: "icon-ticket",
        ticket2: "icon-ticket2",
        tie: "icon-tie",
        toggle: "icon-toggle",
        toggleOff: "icon-toggle-off",
        toggleOn: "icon-toggle-on",
        toiletpaper: "icon-toiletpaper",
        tongue: "icon-tongue",
        tongue2: "icon-tongue2",
        touch: "icon-touch",
        touchPinch: "icon-touch-pinch",
        touchZoom: "icon-touch-zoom",
        trafficCone: "icon-traffic-cone",
        trafficLights: "icon-traffic-lights",
        train: "icon-train",
        train2: "icon-train2",
        transmission: "icon-transmission",
        transmission2: "icon-transmission2",
        tree: "icon-tree",
        tree2: "icon-tree2",
        tree3: "icon-tree3",
        tree4: "icon-tree4",
        tree5: "icon-tree5",
        tree6: "icon-tree6",
        tree7: "icon-tree7",
        triangle: "icon-triangle",
        triangle2: "icon-triangle2",
        trophy: "icon-trophy",
        trophy2: "icon-trophy2",
        trophy3: "icon-trophy3",
        trophy4: "icon-trophy4",
        truck: "icon-truck",
        trumpet: "icon-trumpet",
        tshirt: "icon-tshirt",
        tumblr: "icon-tumblr",
        tumblr2: "icon-tumblr2",
        tux: "icon-tux",
        tv: "icon-tv",
        twitch: "icon-twitch",
        twitter: "icon-twitter",
        twitter2: "icon-twitter2",
        twitter3: "icon-twitter3",
        typewriter: "icon-typewriter",
        typography: "icon-typography",
        umbrella: "icon-umbrella",
        underline: "icon-underline",
        underline2: "icon-underline2",
        undo: "icon-undo",
        undo2: "icon-undo2",
        ungroup: "icon-ungroup",
        unicode: "icon-unicode",
        unite: "icon-unite",
        unlink: "icon-unlink",
        unlink2: "icon-unlink2",
        unlink3: "icon-unlink3",
        unlink4: "icon-unlink4",
        unlink5: "icon-unlink5",
        unlocked: "icon-unlocked",
        unlocked2: "icon-unlocked2",
        upload: "icon-upload",
        upload10: "icon-upload10",
        upload2: "icon-upload2",
        upload3: "icon-upload3",
        upload4: "icon-upload4",
        upload5: "icon-upload5",
        upload6: "icon-upload6",
        upload7: "icon-upload7",
        upload8: "icon-upload8",
        upload9: "icon-upload9",
        usbStick: "icon-usb-stick",
        user: "icon-user",
        userBlock: "icon-user-block",
        userBlock2: "icon-user-block2",
        userCancel: "icon-user-cancel",
        userCancel2: "icon-user-cancel2",
        userCheck: "icon-user-check",
        userCheck2: "icon-user-check2",
        userLock: "icon-user-lock",
        userLock2: "icon-user-lock2",
        userMinus: "icon-user-minus",
        userMinus2: "icon-user-minus2",
        userPlus: "icon-user-plus",
        userPlus2: "icon-user-plus2",
        userTie: "icon-user-tie",
        user2: "icon-user2",
        user3: "icon-user3",
        user4: "icon-user4",
        user5: "icon-user5",
        user6: "icon-user6",
        user7: "icon-user7",
        users: "icon-users",
        users2: "icon-users2",
        users3: "icon-users3",
        users4: "icon-users4",
        users5: "icon-users5",
        vcard: "icon-vcard",
        vector: "icon-vector",
        vector2: "icon-vector2",
        videoCamera: "icon-video-camera",
        videoCameraSlash: "icon-video-camera-slash",
        videoCameraSlash2: "icon-video-camera-slash2",
        videoCamera2: "icon-video-camera2",
        videoCamera3: "icon-video-camera3",
        videoCamera4: "icon-video-camera4",
        videoCamera5: "icon-video-camera5",
        vimeo: "icon-vimeo",
        vimeo2: "icon-vimeo2",
        vimeo3: "icon-vimeo3",
        volume0: "icon-volume-0",
        volume1: "icon-volume-1",
        volume2: "icon-volume-2",
        volume3: "icon-volume-3",
        volume4: "icon-volume-4",
        volume5: "icon-volume-5",
        volumeDecrease: "icon-volume-decrease",
        volumeDecrease2: "icon-volume-decrease2",
        volumeDecrease3: "icon-volume-decrease3",
        volumeHigh: "icon-volume-high",
        volumeHigh2: "icon-volume-high2",
        volumeIncrease: "icon-volume-increase",
        volumeIncrease2: "icon-volume-increase2",
        volumeLow: "icon-volume-low",
        volumeLow2: "icon-volume-low2",
        volumeMedium: "icon-volume-medium",
        volumeMedium2: "icon-volume-medium2",
        volumeMedium3: "icon-volume-medium3",
        volumeMute: "icon-volume-mute",
        volumeMute2: "icon-volume-mute2",
        volumeMute3: "icon-volume-mute3",
        volumeMute4: "icon-volume-mute4",
        volumeMute5: "icon-volume-mute5",
        wall: "icon-wall",
        wallet: "icon-wallet",
        warning: "icon-warning",
        warning2: "icon-warning2",
        watch: "icon-watch",
        watch2: "icon-watch2",
        wave: "icon-wave",
        wave2: "icon-wave2",
        weatherCloudSun: "icon-weather-cloud-sun",
        weatherCloudSun2: "icon-weather-cloud-sun2",
        weatherCloudWind: "icon-weather-cloud-wind",
        weatherCloudWind2: "icon-weather-cloud-wind2",
        weatherCloudy: "icon-weather-cloudy",
        weatherCloudy2: "icon-weather-cloudy2",
        weatherLightning: "icon-weather-lightning",
        weatherLightning2: "icon-weather-lightning2",
        weatherRain: "icon-weather-rain",
        weatherRain2: "icon-weather-rain2",
        weatherSnow: "icon-weather-snow",
        weatherSnow2: "icon-weather-snow2",
        weatherSunWind: "icon-weather-sun-wind",
        weatherSunWind2: "icon-weather-sun-wind2",
        weatherWindy: "icon-weather-windy",
        width: "icon-width",
        windows: "icon-windows",
        windows8: "icon-windows8",
        wink: "icon-wink",
        wink2: "icon-wink2",
        woman: "icon-woman",
        wondering: "icon-wondering",
        wondering2: "icon-wondering2",
        wordpress: "icon-wordpress",
        wordpress2: "icon-wordpress2",
        wrench: "icon-wrench",
        wrench2: "icon-wrench2",
        wrench3: "icon-wrench3",
        xing: "icon-xing",
        xing2: "icon-xing2",
        yahoo: "icon-yahoo",
        yelp: "icon-yelp",
        yinYang: "icon-yin-yang",
        youtube: "icon-youtube",
        youtube2: "icon-youtube2",
        youtube3: "icon-youtube3",
        youtube4: "icon-youtube4",
        zoomIn: "icon-zoom-in",
        zoomIn2: "icon-zoom-in2",
        zoomIn3: "icon-zoom-in3",
        zoomOut: "icon-zoom-out",
        zoomOut2: "icon-zoom-out2",
        zoomOut3: "icon-zoom-out3",
    };
    return Icons;
}());
exports.Icons = Icons;
